// extracted by mini-css-extract-plugin
export var body = "_f4-0";
export var sectionHeader = "_f4-4";
export var shortcutColumns = "_f4-2";
export var shortcutList = "_f4-1";
export var shortcutSection = "_f4-3";